import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';

export const selectBlackList = (state: IRootState) => state.blacklist.list;

export const isBlackListEmpty = (state: IRootState) =>
  get(state, 'blacklist.list', []).length === 0;
